export default __webpack_public_path__ + "static/media/b-9.b04e9ed9.png";